//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
(function () {
    'use strict';
    angular.module('container.components')
        .directive('srsngFirstLoginDialog', srsngFirstLoginDialog);

    function srsngFirstLoginDialog($rootScope, Localization, userSettingsService, authenticationService, Event) {

        return {
            restrict: 'E',
            templateUrl: 'container/ui/app/components/first-login-dialog/first-login-dialog.html',
            scope: {
             },
            controller: controller,
            link: link
        };

        function controller($scope, POLICY_VERSION) {

            $scope.showFirstLoginDialog = false;
            $scope.policyVersion = POLICY_VERSION;
            $scope.currentStep = "cookiePolicy";
            $scope.buttonText = "container.button.next";

            $scope.nextOrAccept = nextOrAccept;
            $scope.declineAndLogout = declineAndLogout;
            $scope.resetDialog = resetDialog;
            $scope.removeUserSetting = removeUserSetting;

            $rootScope.$on(Event.USER_LOGGED_OUT, () => {
                $scope.showFirstLoginDialog = false;
            });

            function removeUserSetting() {
                userSettingsService.removeUserSetting('container', 'commitmentToDataPrivacy');
            }

            function nextOrAccept() {
                if ($scope.currentStep === 'cookiePolicy') {
                    $scope.currentStep = 'termsOfUse';
                } else if ($scope.currentStep === 'termsOfUse') {
                    $scope.currentStep = 'commitmentToDataPrivacy';
                    $scope.buttonText = 'container.button.accept';
                } else if ($scope.currentStep === 'commitmentToDataPrivacy') {
                    confirmCommitmentToDataPrivacy();
                }
            }

            function declineAndLogout() {
                authenticationService.logout();
            }

            function confirmCommitmentToDataPrivacy() {
                userSettingsService.loadUserSetting('container', 'commitmentToDataPrivacy')
                    .then(commitmentToDataPrivacy => {
                        let newCommitmentToDataPrivacy = { "agreements": [] };
                        if (commitmentToDataPrivacy && commitmentToDataPrivacy.agreements) {
                            newCommitmentToDataPrivacy = commitmentToDataPrivacy;
                        }
                        // Implmenet "new agreements versioning" - currently the agreement version is hardcoded to version 5.0.0
                        newCommitmentToDataPrivacy.agreements.push({
                            "version": $scope.policyVersion,
			                "accepted": true,
			                "date": new Date()
                        });
                        userSettingsService.saveUserSetting('container', 'commitmentToDataPrivacy', newCommitmentToDataPrivacy);
                        $scope.showFirstLoginDialog = false;
                    });
            }

            function showDialogIfCookiesNotAccepted() {
                userSettingsService.loadUserSetting('container', 'commitmentToDataPrivacy')
                    .then(commitmentToDataPrivacy => {
                        const agreement = (commitmentToDataPrivacy && commitmentToDataPrivacy.agreements) ? _.last(commitmentToDataPrivacy.agreements) : {};
                        if (agreement.version !== $scope.policyVersion || agreement.accepted !== true) {
                            $scope.showFirstLoginDialog = true;
                        }
                    }, () => {
                        $scope.showFirstLoginDialog = true;
                    });
            }

            function resetDialog() {
                $scope.showFirstLoginDialog = false;
                setTimeout(function () {
                    showDialogIfCookiesNotAccepted();
                }, 1500)
            }

        }

        function link($scope, $element, attrs) {
            $scope.resetDialog();
        }

    }

})();

